<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Base Corredores</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <div>
            <b-row class="mb-3">
              <b-col sm = "2">
                <label>Póliza</label>
              </b-col>  
              <b-col sm = "2">
                <b-form> 
                  <b-input-group @change="consulta_CorrPol()">
                    <b-form-input type="number" v-model="datosFormulario.poliza"/>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.contratante" :disabled="true"/>
                </b-input-group>
              </b-col>
              <b-col sm="4">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.NombreCont" :disabled="true"/>
                </b-input-group>
              </b-col>
            </b-row>

          </div>
          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Base Corredores</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
                 <el-table-column label="" min-width="200px" align="center">
                <template slot-scope="scope">
                    <el-button
                          size="mini"
                          type="primary"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  <b-modal
      title="Modificación Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalModificar"
      @ok="saveRow();"
      @cancel="modalModificar = false"
    >
    
      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.corredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                   disabled
                  v-model="datosFormularioModal.contacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                   disabled
                  v-model="datosFormularioModal.mail">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Líneas</label>
        </b-col>
        <b-col sm="4">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.rli"
                value="Si"
                unchecked-value="No"
              ></b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Prórrogas</label>
        </b-col>
        <b-col sm="4">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.rpr"
                value="Si"
                unchecked-value="No"
              ></b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Última Modificación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.femodif">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Usuario</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.usumodif">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
    
    </b-modal>

    <!-- Agregar Contacto -->
    <b-modal
      title="Nuevo Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalNuevo"
      @ok="saveRow();"
      @cancel="modalNuevo = false"
    >

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.corredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.contacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.mail">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Tipo de correos</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox-group
                v-model="datosFormularioModal.procesos"
                :options="procesos"
                
              ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>

    </b-modal>
  
    <!-- Eliminar -->
    <b-modal
      title="Eliminar Contacto"
      cancel-title="Cancelar"
      ok-title="Eliminar"
      class="modal-success"
      v-model="modalEliminar"
      @ok="eliminarGuardar();"
      @cancel="modalEliminar = false"
    >
        Se eliminará el siguiente contacto:
        <br><br>
        Corredor: {{datosFormularioModal.corredor}} 
        <br>
        Contacto: {{datosFormularioModal.contacto}} 
    </b-modal>

    <!-- Desactivar Procesos-->
    <b-modal
      title="Desactivar Procesos"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalDesactivar"
      @ok="Desactivar"
      @cancel="modalDesactivar = false"
    >
      Se desactivara los correos automáticos de los siguientes corredores, ¿desea continuar?
      
    </b-modal>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConCorredor from "@/components/services/apiConCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "BaseAsegurado",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      modalModificar : false,
      modalEliminar : false,
      modalNuevo : false,
      modalDesactivar: false,
      hasCorredor : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      nombreexcel: "BaseCorredores",
      titles: [
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "contacto",
          label: "Nombre Contacto",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "mail",
          label: "Email Contacto",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "rli",
          label: "Líneas",
          align: "center",
          minwidth:'50'
        },
        {
          prop: "rpr",
          label: "Prórrogas",
          align: "center",
          minwidth:'60'
        }
       
      ],
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      datosFormularioModal: {
          codcorredor: "",
          corredor: "",
          contacto: "",
          mail_old: "",
          mail: "",
          rli: "",
          rpr: "",
          femodif: "",
          usumodif: "",
      },
      
      mostrarFechas: true,
      datosFormulario: {
          NombreCont: "",
          contratante: "",
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      multipleSelection: [],
      
      valEjecutivos: [],
      procesos: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        // rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.recuperar_DatCorrPol(row);
          }
          botones.push(obj);
          
          return botones;

    },

    Desactivar(){
      this.$Progress.start();
    
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      // const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          // if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          // }

      }

      var CorredorMarcados = "";
      var index = 0;
      
      for (index = 0; index < marcados.length; ++index) {
        CorredorMarcados += marcados[index]["idcontacto"] + ',';
      }

      // desactivar_Procesos

      console.log(CorredorMarcados);

      if (CorredorMarcados != ""){
        CorredorMarcados = CorredorMarcados.slice(0, -1)
        apiConCorredor
          .desactivar_Procesos(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            CorredorMarcados
          )
          .then(response => {

            this.$Progress.finish();
            this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );

                this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      else if (CorredorMarcados == undefined){
         this.crearNotificacion(
                "Error",
                "Debe seleccionar al menos un registro.",
                "success"
              );
      }

      this.$Progress.finish();
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

    valmarcados(p_opcion){
  
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

       this.multipleSelection = marcados;
      if (this.multipleSelection.length > 0){
         if (p_opcion == 'D') {this.modalDesactivar = true}
      }else{
        this.crearNotificacion(
                "Marcar",
                "No tiene registros seleccionados.",
                "error"
              );
      }
      
    },
    
    pre_insertar() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;
  
      this.datosFormulario.contratante ="";
      this.datosFormulario.NombreCont ="";
      this.datosFormulario.poliza = "";
      this.hasCorredor = false;
      
      return apiConCorredor
        .pre_insercion_CorrPol(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.poliza='';

          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      this.datosFormulario.poliza == '' ? '': this.datosFormulario.poliza;
      
      var p_poliza = this.datosFormulario.poliza == ''? '0' : this.datosFormulario.poliza;

      return apiConCorredor
      .recuperar_CorrPol(p_email, p_poliza)
          .then( (response)=>{

            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "fecha"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      ///COLUMNAS ESCRIBIR
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      //for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Código Corredor" + "</td>\n"; 
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Mail Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Líneas" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Prórrogas" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Última Modificación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Usuario" + "</td>\n";

      //}
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      let diadiapol = '';
      let decididor = '';
      for (var key in this.data) {
        if(this.data[key]["contacto"] === undefined){ 
          this.data[key]["contacto"] = "";
        }
        if(this.data[key]["mail"] === undefined){ 
          this.data[key]["mail"] = "";
        }
        if(this.data[key]["rli"] === undefined){ 
          this.data[key]["rli"] = "";
        }
        if(this.data[key]["rpr"] === undefined){ 
          this.data[key]["rpr"] = "";
        }
        if(this.data[key]["femodif"] == undefined){ 
          this.data[key]["femodif"] = "";
        }
        if(this.data[key]["usumodif"] == undefined){ 
          this.data[key]["usumodif"] = "";
        }
      
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["corredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["codcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["contacto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["mail"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["rli"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["rpr"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["femodif"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["usumodif"] + "</td>\n";
        
        cuerpo += "</tr>\n";
      }

      //Data bloque 1
      
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    consulta_CorrPol: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasCorredor = false;
      var p_poliza = this.datosFormulario.poliza == '' ? '0': this.datosFormulario.poliza;
      var p_email = this.$session.get("mail");
      
      if ((p_poliza==0)){
          this.datosFormulario.contratante ="";
          this.datosFormulario.NombreCont ="";
          this.mensaje= "Ingrese Póliza.";
          this.variant="warning";
          this.showAlert();
          return false;
      }
      return apiConCorredor
        .consulta_CorrPol(
          p_email, p_poliza
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoCorredor = response.data.res;
         var InfoCorredorDir = response.data.res1;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.contratante = InfoCorredor[i]["contratante"];
            this.datosFormulario.NombreCont = InfoCorredor[i]["nombrecont"];
          }
          this.hasCorredor = true;
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    nuevoContacto: function(){
      this.datosFormularioModal.corredor = this.datosFormulario.NombreCorred;
      this.datosFormularioModal.codCorredor = this.datosFormulario.codCorredor;  
  
      this.datosFormularioModal.contacto = "";
      this.datosFormularioModal.mail = "";
 
      this.modalNuevo = true;
    },

recuperar_DatCorrPol: function( row ) {       
              this.datosFormularioModal.codcorredor = row.codcorredor;
              this.datosFormularioModal.corredor = row.corredor;
              this.datosFormularioModal.contacto = row.contacto;
              this.datosFormularioModal.mail_old = row.mail;
              this.datosFormularioModal.mail = row.mail;
              this.datosFormularioModal.rli = row.rli == 'Si'? 'Si' : 'No';
              this.datosFormularioModal.rpr = row.rpr == 'Si'? 'Si' : 'No';
              this.datosFormularioModal.usumodif = row.usumodif;
              this.datosFormularioModal.femodif = row.femodif;
              this.modalModificar = true;
    },

    intersection(o1, o2) {
    return Object.keys(o1).concat(Object.keys(o2)).sort().reduce(function (r, a, i, aa) {
        if (i && aa[i - 1] === a) {
            r.push(o1[a].value);
        }
         return r;
    }, []);
    },

  saveRow() { 
      let rows = this.datosFormularioModal;
    
        //Modificar
        return apiConCorredor
          .editar_CorrPol(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.poliza,
            rows.codcorredor,
            rows.contacto,
            rows.mail_old,
            this.datosFormularioModal.mail,
            rows.rli,
            rows.rpr
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha actualizado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          }
          )
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
    },
  
    eliminarContacto(row){
      this.datosFormularioModal.codCorredor = row.codCorredor;
      this.datosFormularioModal.corredor = row.corredor;
      this.datosFormularioModal.contacto = row.contacto;
      this.datosFormularioModal.idcontacto = row.idcontacto;
      this.modalEliminar = true;
    },

    eliminarGuardar(){
      return apiConCorredor
          .eliminar_CorrPol(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormularioModal.idcontacto
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Eliminar",
                "Se ha eliminado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    }
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();  
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
        }
      })
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
